export const amazonTokens = {
  colors: {
    navy: "#253C6D",
    blue: "#30497D",
    lightBlue: "#455B8A",
    gold: "#F2842F",
    orange: "#F2842F",
    teal: "#007185",
    green: "#067d62",
    red: "#b12704",
    pageBg: "#eaeded",
    cardBg: "#ffffff",
    textPrimary: "#0f1111",
    textSecondary: "#565959",
    border: "#d5d9d9"
  },
  spacing: {
    navHeight: "60px",
    subNavHeight: "39px",
    pagePadding: "1rem",
    cardPadding: "0.75rem",
    sectionGap: "1.25rem"
  },
  typography: {
    fontFamily: '"Amazon Ember", Arial, sans-serif',
    productTitle: "text-sm leading-snug",
    price: "text-xl font-normal",
    mrp: "text-xs text-slate-500 line-through"
  },
  shadows: {
    card: "0 2px 5px rgba(15,17,17,0.15)",
    cardHover: "0 4px 12px rgba(15,17,17,0.2)",
    dropdown: "0 4px 14px rgba(15,17,17,0.25)",
    sticky: "0 2px 4px rgba(0,0,0,0.25)"
  }
} as const;

export const trendingSearches = [
  "iphone 16",
  "laptop deals",
  "air fryer",
  "running shoes",
  "kindle",
  "wireless earbuds",
  "smart watch",
  "gaming chair"
];

export const deliveryLocations = [
  { pincode: "1000", city: "Addis Ababa" },
  { pincode: "2000", city: "Hawassa" },
  { pincode: "3000", city: "Adama" },
  { pincode: "4000", city: "Bahir Dar" },
  { pincode: "5000", city: "Dire Dawa" }
];
